(ns capra.readers
  "ClojureScript tag literal installation.
   Call (install!) once at app startup — same pattern as time-literals."
  (:require
   [cljs.reader :as reader]
   [capra.protocol :as proto]))

(defn install!
  "Install #rpc/* tag literal readers into the CLJS reader.
   Must be called before any EDN containing capra tags is parsed."
  []
  (reader/register-tag-parser! 'rpc/ref proto/read-ref)
  (reader/register-tag-parser! 'rpc/cap proto/read-cap)
  (reader/register-tag-parser! 'rpc/fn  proto/read-fn))
